<div class="lcd digital" [style]="lcdStyle" fxLayout="row">
  <div class="digit-field" *ngFor="let digit of values" [style]="fieldStyle" >
    <div class="digit glow" [style]="digitStyle">{{digit}}</div>
  </div>
</div>
